import { useQuery } from '@tanstack/react-query';
import { getTaskItemById } from '../api/tasks';

export function useTaskItem(id: string | null) {
  return useQuery({
    queryKey: ['taskItem', id],
    queryFn: () => (id ? getTaskItemById(id) : Promise.resolve(null)),
    enabled: !!id,
  });
}
